import React from 'react';
import carimage from '../image/car.png';
import busimage from '../image/bus.png';
import workingimage from '../image/work.png';
import airplaneimage from '../image/airplane.png';
import trainimage from '../image/train.png';
import bikeimage from '../image/bike.png';
import EcoRequireAmount from './EcoRequireAmount';



class TransportationCal extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            distance:0,
            transport:null,
            count:null,
            resultcode:null,
            co2Emissions:0,
            resultYn:'N',
        };
        this.resultTextRef  = React.createRef();
    }

  handleDepature = (e) =>{
    this.setState({departure:e.target.value});
  }

  handleDestination = (e) =>{
    this.setState({destination:e.target.value});
  }
  handleTransport = (e) =>{
    this.setState({transport:e.target.value});
  }
  handleCount = (e) =>{
    this.setState({count:e.target.value});
  }

  handleDistance = (e) =>{
    this.setState({distance:e.target.value});
  }

  inputValidate = (e) => {
    const {distance} = this.state;
    const { transport } = this.state;
    const { count } = this.state;
    if(distance==null || distance<=0){
      alert("거리를 입력하세요.");
      return;
    }

    if(count==null || count<=0){
      alert("인원수를 입력하세요.");
      return;
    }

    this.transVal();
  }

  transVal = () =>{
    const {distance} = this.state;
    const { transport } = this.state;
    const { count } = this.state;
    var postData = {'distance':distance,
                    'transport': transport ,
                    'count': count };
    fetch('https://ecofestivalcalculate.du.r.appspot.com/tranportCal',{
        headers : {'Content-Type' : 'application/json'},
        method : 'POST',
        body: JSON.stringify(postData)})
        .then(res=>res.json())
        .then(data=> this.fn_callback(data))
  }

  fn_callback = (data) =>{
    let reulstValue= data.resultvalue.toFixed(4);
    if(data.resultcode='0000'){
      this.setState({co2Emissions:reulstValue,resultYn:'Y'});
      this.resultTextRef.current.focus();
    }
  }



  render() {
    let ecoRequireAmountDiv;
    let {co2Emissions} = this.state;

    if(this.state.resultYn == 'Y'){
      ecoRequireAmountDiv = <EcoRequireAmount co2Emissions={co2Emissions}/>
    }

    return (
      <div className="main_body_content">
        <h2 > 1. 출발지와 도착지 거리를 입력하세요</h2>
        <div className="locationComboDiv">
        <input id="distanceInput" style={countInputstyle} onChange={this.handleDistance} type="number" name="distance"/>
        <div style={hstyl2}> : KM </div>
        </div>

        <div>
          <h2> 2. 이동수단을 선택하세요.</h2>
          <div className="RadioDiv">
            <label style={radiostyle}>
              <input type="radio" name="trnasport" value="car"  onChange={this.handleTransport}/>
              <img padding="30px" width="100px" src={carimage}/>
            </label>
          <label border="1px" style={radiostyle}>
            <input  type="radio" name="trnasport" value="bus" onChange={this.handleTransport}/>
            <img padding="30px" width="100px"   src={busimage}/>
          </label>
          <label  style={radiostyle}>
            <input type="radio" name="trnasport" value="work" onChange={this.handleTransport}/>
            <img padding="30px" width="100px" height="100px"  src={workingimage}/>
          </label>
          <label style={radiostyle}>
            <input type="radio" name="trnasport" value="airplane" onChange={this.handleTransport}/>
            <img padding="30px" width="100px" src={airplaneimage}/>
          </label>
          <label style={radiostyle}>
            <input type="radio" name="trnasport" value="train" onChange={this.handleTransport}/>
            <img padding="30px" width="100px" src={trainimage}/>
          </label>
          <label style={radiostyle}>
            <input type="radio" name="trnasport" value="bike" onChange={this.handleTransport}/>
            <img padding="30px" width="100px" src={bikeimage}/>
          </label>

          </div>
        </div>

          <div>
            <h2> 3. 인원 수를 입력하세요. </h2>
              <div style={countInputDivstyle}>
                <input id="inputCount" style={countInputstyle} onChange={this.handleCount} type="number" name="count"/>
                <div style={hstyl2}> : 명 </div>
              </div>
          </div>

          <div style={inputButtonDiv}>
            <button style={inputButtonStyle} onClick={this.inputValidate}> 계산
            </button>
          </div>
          <div>
          </div>

          <div ref={this.resultTextRef} style={resultTextStyle}>
            <div style={resultText1Style}>
              CO₂ 배출량 :
            </div>
            <div style={resultText2Style}>
              {this.state.co2Emissions + "  kg"}
            </div>
          </div>
          {ecoRequireAmountDiv}

        </div>
    );
  }
}


const hstyl2 ={
  color: "black",
  fontSize : "20px",
  marginRight: "20px",

}

const hstyle = {
  color: "black",
  fontSize : "20px",
  marginRight: "20px",
  paddingTop: "10px"
}
const combostlye = {
  width:"120px",
  height: "50px",
  color: "black",
  fontSize : "15px",
  marginRight: "20px"
}
const radiostyle = {
  flexdirection: "column",
  margin:"40px"
}
const countInputstyle ={
  height :"30px",
  marginRight:"30px"
}
const countInputDivstyle ={
  flexdirection: "column",
  display:"flex",
  justifyContent: "center",
  paddingTop:"20px",
  height:"100px"
}
const inputButtonDiv= {
  height:"100px"
}
const inputButtonStyle={
  height:"50px",
  width:"150px",
  color:"white",
  background:"#002060"
}
const resultTextStyle= {
  flexdirection: "column",
  display:"flex",
  justifyContent: "center",
  paddingTop:"20px",
  height:"100px",
  fontSize:"20px",
  justifyContent:"center",
}
const resultText1Style={
  marginRight :"20px",
  width:"200px"
}

const resultText2Style={
  width:"200px"
}
TransportationCal.defaultProps = {
    menuName: 'Default Name',
};

export default TransportationCal;
